'use client'

import { BackHeader } from '../@header/BackHeader'
import { WithT } from '@/locales/types'
import { IArticle } from '@/api/interfaces/IArticle'
import { AuthUser } from '@/store/auth'
import { ArticleActions } from './ArticleActions'

interface ArticleDetailHeaderProps {
  article: IArticle.IArticleDetailRO
  user?: AuthUser
}

export const ArticleDetailHeader = ({
  article,
  translations,
}: WithT<ArticleDetailHeaderProps>) => {
  return (
    <BackHeader
      rightComponent={
        <ArticleActions article={article} translations={translations} />
      }
    />
  )
}
